import { Component, OnInit, ViewChild, AfterViewInit, ViewEncapsulation, Input, Renderer2, ChangeDetectorRef } from '@angular/core';
import { CompositeFilterDescriptor, filterBy, process, State } from '@progress/kendo-data-query';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { GItem } from '@app/cp/shared/models/GItem';
import { CustomerService } from '@app/cp/shared/services/customer.service';
import { DropDownListComponent, DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { Subscription } from 'rxjs';
import { PageChangeEvent, SelectableSettings, SelectionEvent } from '@progress/kendo-angular-grid';
import { DQOIComponent } from '@app/cp/dqoi/dqoi.component';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { BaseDQOIComponent } from '@app/cp/shared/base-components/base-dqoi.component';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { WindowContents } from '@app/cp/shared/enums/windowContents';
import { DispatchData } from '@app/cp/shared/models/DispatchData';
import { MSCLFilterClass } from '@app/cp/shared/classes/filters/MSCLFilterClass';
import { aggregateBy } from '@progress/kendo-data-query';
import { DispatchSearchType } from '@app/cp/shared/enums/dispatchSearchType';
import { DomSanitizer } from '@angular/platform-browser';
import { GridComponent } from "@progress/kendo-angular-grid";
import { element } from "protractor";
import * as _ from 'lodash';
import { ActivatedRoute, Params } from '@angular/router';
import { CommonParam } from '../../shared/models/CommonParam';
import { BaseMessageInfo } from '../../shared/models/BaseMessageInfo';
import { DQOIService } from '../../shared/services/DQOI.service';
import { v_InventoryXferHistoryBus } from '../../shared/models/v_InventoryXferHistoryBus';
import { BaseGridEditFormLinesComponent } from '../../shared/base-components/base-grid-edit-formlines.component';
import { FormControl, FormGroup } from '@angular/forms';
import { SaveMode } from '../../shared/enums/SaveMode';
import { BaseGridEditLineComponent } from '../../shared/base-components/base-grid-editline.component';
import { InventoryService } from '../../shared/services/inventory.service';
import { GenericSearchComponent } from '../../shared/search/generic-search/generic-search.component';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { v_InvoiceLineItemBus } from '../../shared/models/v_InvoiceLineItemBus';
import { InvoiceService } from '../../shared/services/invoice.service';
import { v_InvoiceBus } from '../../shared/models/v_InvoiceBus';
import { InvoiceActionBus } from '../../shared/models/InvoiceActionBus';
import { InvoiceInfo } from '../../shared/models/InvoiceInfo';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'invoice-action',
    templateUrl: './invoice-action.component.html',
    styleUrls: ['./invoice-action.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InvoiceActionComponent extends BaseGridEditLineComponent<InvoiceActionBus, null, InvoiceService>  {
    //dispatchStatusNameCF: MSCLFilterClass;
    //locationNameCF: MSCLFilterClass;
    //priorityNameCF: MSCLFilterClass;

    constructor(svc_data: InvoiceService, globals: GlobalsService, private svc_cust: CustomerService, private qry_rd: DQOIReferenceDataQuery, private sanitizer: DomSanitizer, private activatedRoute: ActivatedRoute, renderer: Renderer2, cd: ChangeDetectorRef, private svc_dqoi: DQOIService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.className = "InvoiceActionBus";
        this.appCode = "InvoiceAction";
        this.subs_dataRef = this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();
        this.getRouteParams();
        this.advSearchParam = new CommonParam();
        this.saveMode = SaveMode.individual;
        this.allData = this.allData.bind(this);
        //this.setSelectableSettings();
    }
    subs_dataRef: Subscription;
    // Dynamic parameters for this component's route: /example-params/:first/:second
    @ViewChild('genSearch') protected genSearch: GenericSearchComponent;

    routeParams: Params;

    // Query parameters found in the URL: /example-params/one/two?query1=one&query2=two
    queryParams: Params;
    getRouteParams() {
        // Route parameters
        this.activatedRoute.params.subscribe(params => {
            this.routeParams = params;
        });

        // URL query parameters
        this.activatedRoute.queryParams.subscribe(params => {
            this.queryParams = params;
        });
    }
    ngAfterViewInit() {
        console.log("phsrch->avi:", this.genSearch);
        this.genSearch.clear();
    }
    override ngOnDestroy() {
        super.ngOnDestroy();
        CommonFunctions.unsubscribe(this.subs_dataRef);
    }
    detailOpened: boolean = false;

    createForm() {
        //this.editForm = new FormGroup({
        //    'ignoreAvgCost': new FormControl(),

        //});

    }
    setForm() {
        //    this.editForm.patchValue({
        //        ignoreAvgCost: this.selectedData.ignoreAvgCost
        //    });
    }

    advSearchParam: CommonParam = new CommonParam();
    doAdvSearch(param: CommonParam) {
        console.log("doAdvSearch:", this.advSearchParam);
        this.dataLoading = true;
        this.svc_dqoi.generic_Search(this.advSearchParam).subscribe((info: BaseMessageInfo) => {

            let gridDataOriginal = info.primaryReturn; //JSON.parse(info.primaryReturn);
            this.ListData = gridDataOriginal;
            console.log('Generic Search: ', gridDataOriginal, info);
            this.dataLoading = false;
        });

    }
    advSearchCancel(e: any) {

    }

    //getData() {
    //    this.dataLoading = true;
    //    let search: DispatchSearch = new DispatchSearch();

    //    search.customerId = this.selected_customer.value;
    //    search.locationId = (this.selected_location !== undefined && this.sloweselected_location !== null) ? this.selected_location.value : "";
    //    search.openStatusesOnly = this.openStatusesOnly;
    //    search.type = DispatchSearchType.all;
    //    if (this.selected_type_value === "S") {
    //        search.type = DispatchSearchType.service;
    //    }
    //    else if (this.selected_type_value === "C") {
    //        search.type = DispatchSearchType.construction;
    //    }
    //    search.skip = this.skip;
    //    search.note = this.search_note;
    //    CommonFunctions.unsubscribe(this.subs_data);
    //
    //    this.subs_data = this.svc_data.GetDispatchBySearch(search).subscribe(data => {
    //        this.ListData = data;
    //
    //        this.dataLoading = false;;
    //        this.getLogo(this.selected_customer.value);
    //    });
    //}

    filterClear() {
        this.selectedData = null;
        this.gridData = null;
    }
    rowSelected(e: SelectionEvent) {
        this.selectedData = e.selectedRows[0].dataItem;
    }
    detailId: any;
    details(data: InvoiceActionBus, code: string) {

        //    let id = code == "D" ? data.dispatchId : data.orderId;
        //    let target: SearchTarget = SearchTarget.dispatch;
        //    let isConstruction = false;
        //    if (code == "D") { //Dispatch,Job
        //        if (data.isJob) {
        //            target = SearchTarget.job;
        //            isConstruction = true;
        //        }
        //    }
        //    else {
        //        target = SearchTarget.order;
        //    }
        //    this.dqoiPopup(id, target, isConstruction);
        //    //this.detailOpened = true;
        //    //this.detailId = "1:" + data.dispatchId;
        //    ////this.dqoi.setupFromId(data.dispatchId);

    }
    closeDetail() {
        //this.dqoi.

        this.detailOpened = false;
    }
    detailsData: DispatchData;
    dqoiPopup(id: any, target: SearchTarget = SearchTarget.dispatch, isConstruction: boolean = false) {
        let data: DispatchData = new DispatchData();
        data.id = id;
        data.target = target;
        data.isConstruction = isConstruction;
        data.viewDispatch.dispatchId = id;
        console.log("dsh-dqoiPop: ", data);
        this.detailsData = data;
        //this.cpPopWindow({ contentType: WindowContents.viewDispatch, boardData: data });
    }
    public cpActiveChildComp: number;
    public cpWindowData: any;
    public cpShowWindow: boolean = false;
    public cpContentTypes = WindowContents;
    cpPopWindow(injected: any) {
        this.cpActiveChildComp = injected.contentType;
        this.cpWindowData = injected.boardData;
        this.cpShowWindow = true;
    }
    //processGridData() {
    //    this.dispatchStatusNameCF = new MSCLFilterClass('dispatchStatusName', 'dispatchStatusName', this.gridData);
    //    this.locationNameCF = new MSCLFilterClass('locationName', 'locationName', this.gridData);
    //    this.priorityNameCF = new MSCLFilterClass('priorityName', 'priorityName', this.gridData);
    //    this.expandGrid();
    //}
    //@ViewChild(GridComponent) grid: GridComponent;

    //expandGrid(){
    //    let length = this.gridData.length,
    //        element = null;
    //    for (let i = 0; i < length; i++) {
    //        element = this.gridData[i];
    //        this.grid.expandRow(i);
    //    }
    //}
    //checkBoxChanged(e: any, dataItem, rowIndex, column, columnIndex, setEditMode: boolean = true) {
    //
    //    super.checkBoxChanged(e, dataItem, rowIndex, column, columnIndex, setEditMode);
    //}
    //saveIndividual(dataObj: v_InvoiceLineItemBus): Promise<BaseMessageInfo> {
    //    let busObj: v_InventoryXferHistoryBus = this.getChangedObject(dataObj);
    //    var isAdded = busObj.isAdded;
    //    let retInfo: BaseMessageInfo = new BaseMessageInfo();
    //    //do this for now because only updating IgnoreAvgCost
    //    retInfo.primaryReturn = dataObj;
    //    return new Promise((resolve, reject) => {
    //        this.svc_data.saveInventoryTransferHistory(busObj).toPromise().then((info: BaseMessageInfo) => {

    //            if (!info.saveError) {
    //                this.notify("Ignore Average Cost Updated Successfully!");
    //            }
    //            //if (data != null) {
    //            //    let newDataObj: v_DispatchNoteBus = new v_DispatchNoteBus();
    //
    //            //    newDataObj.setFromBusobj(data);
    //            //    if (data.insertDt == data.updatedt) {
    //            //        newDataObj.insertDt = DateFunctions.getDateNow();
    //            //        newDataObj.updatedt = newDataObj.insertDt;
    //            //    }
    //            //    else {
    //            //        newDataObj.updatedt = DateFunctions.getDateNow();

    //            //    }
    //            //    newDataObj.dispatchNotes = data.dispatchNotes1;
    //            //    newDataObj = this.setFromReferenceData(newDataObj);
    //            //    retInfo.primaryReturn = newDataObj;
    //            //    this.notify(this.appCode + " Saved Successfully!");
    //            //    let dMmessage: DQOIMessage = new DQOIMessage();

    //            //    dMmessage.messageData = this.parentId;
    //            //    dMmessage.messageType = MessageType.childSaved;
    //            //    this.dqoiMessage.emit(dMmessage);
    //            //}
    //            //else {
    //            //    retInfo.message = "Error Saving"
    //            //    retInfo.saveError = true;
    //            //    this.saveError(null, retInfo.message);
    //            //}
    //            //this.dataLoading = false;
    //            //if (this.GridEditMode == 1) {
    //            //    this.doParentAction(this.parentId, "GETPAGEDATA", "DISPATCHNOTES");
    //            //}
    //            resolve(retInfo);
    //        });
    //    });
    //}
    public allData(indata: ExcelExportData): ExcelExportData {
        if (!this.gridData) this.gridData = [];
        const result: ExcelExportData = {
            data: process(this.gridData as any, {}).data,
        };
        return result;
    }
    spcProcessSubs: Subscription;
    specialProcess() {
        let param: CommonParam = new CommonParam();
        CommonFunctions.unsubscribe(this.spcProcessSubs);
        this.spcProcessSubs = this.svc_data.specialProcess(param).subscribe((info: InvoiceInfo) => {
            console.log("spcPrc: ", info);
        });
    }

}
